import { render, staticRenderFns } from "./Guestbook.vue?vue&type=template&id=7c5eb9e4"
import script from "./Guestbook.vue?vue&type=script&lang=js"
export * from "./Guestbook.vue?vue&type=script&lang=js"
import style0 from "./Guestbook.vue?vue&type=style&index=0&id=7c5eb9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports